const RECENT_JOBS_COOKIE = "predppi_recent_jobs";

const cookieOptions = "path=/; max-age=2592000; samesite=lax";

export function readRecentJobs() {
  const cookie = document.cookie
    .split("; ")
    .find(row => row.startsWith(`${RECENT_JOBS_COOKIE}=`));

  if (!cookie) return [];

  try {
    const jobs = JSON.parse(decodeURIComponent(cookie.split("=")[1]));
    return (Array.isArray(jobs) ? jobs : [])
      .map(job => (typeof job === "string" ? { job_id: job } : job))
      .filter(job => job?.job_id);
  } catch (error) {
    return [];
  }
}

export function saveRecentJobs(jobs) {
  document.cookie = `${RECENT_JOBS_COOKIE}=${encodeURIComponent(
    JSON.stringify(jobs.slice(0, 10))
  )}; ${cookieOptions}`;
}

export function addRecentJob(job) {
  const recentJobs = readRecentJobs().filter(item => item.job_id !== job.job_id);
  recentJobs.unshift(job);
  saveRecentJobs(recentJobs);
  return recentJobs;
}
